import * as React from 'react';
import { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Grid, Typography } from '@mui/material';

export default function ConfirmModal({ open, onClose, title, bodyText }: any) {
  const [openDialog, setOpen] = useState(open);

  useEffect(() => {
    setOpen(open);
  }, [open])

  return (
    <React.Fragment>
      <Dialog
        open={openDialog}
        onClose={(_e) => onClose(false)}
      >
        <DialogTitle>{title || 'Remove'}</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} padding={2}>
            <Grid item xs={12}>
                <Typography variant="body1">{bodyText || 'Do you want to remove this?'}</Typography>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={(_e) => onClose(false)}>Cancel</Button>
          <Button onClick={(_e) => onClose(true)}>Save</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
